module.exports = __webpack_public_path__ + "assets/img/image10.aba6afdd.png";